
import './RightsService.less'
import useHistory from '@/hooks/useHistory'
import { setCommand } from "@/utils/jsapi-auth";
import userIdMap from "@/const"

const RightsService = () => {
  const history = useHistory()

  const handeToForm = () => {
    history.push('/ApplicationIssues?page=RightsService', 'route')
  }

  const handleChat = () => {
    setCommand('openChatByUserId', {
      userId: userIdMap['wqj']
    })
  }

  return (
    <div className='pg-rights-service'>
      <div className="row">
        <div className="row-left">
          <img className="icon" src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/organization/icon-05.png' />
          <div>法律援助</div>
        </div>
        <div className="row-right" onClick={handeToForm}>填写援助申请单</div>
      </div>
      <div className="row">
        <div className="row-left">
          <img className="icon" src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/organization/icon-06.png' />
          <div>法律咨询</div>
        </div>
        <div className="row-right" onClick={handleChat}>联系在线律师</div>
      </div>
    </div>
  )
}

export default RightsService